import { Component } from 'react';
import PropTypes from 'prop-types';

class ListenState extends Component {
  constructor(...args) {
    super(...args);

    this.unsubscribe = null;
    this.state = { next: null };
  }

  componentDidMount() {
    const { state } = this.props;

    this.subscription = state.subscribe(
      next => this.setState({ next }),
    );
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  render() {
    const { children: render } = this.props;
    return this.state.next ? render(this.state.next) : null;
  }
}

ListenState.propTypes = {
  state: PropTypes.shape({
    value: PropTypes.any,
    subscribe: PropTypes.func,
  }),
  children: PropTypes.func.isRequired,
};

export default ListenState;



// WEBPACK FOOTER //
// ./src/components/ListenState.js